import { render, staticRenderFns } from "./TebligatTeslipTipiPicker.vue?vue&type=template&id=68a32452"
import script from "./TebligatTeslipTipiPicker.vue?vue&type=script&lang=ts"
export * from "./TebligatTeslipTipiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports